import store from '~/javascripts/store.js';

const AmountButtonsExperiment = {
  showAmountInputExperiment: function (showAmountInput = false) {
    store.donateForm.showAmountInput = showAmountInput;
  },

  setProductVariant: function (product = 'one-time-and-monthly') {
    store.donateForm.productVariant = product;
  },

  setOptimizelyParams: function (params = {}) {
    store.donateFormButtonAmounts.optimizelyParams = params;
  },

  setOptimizelyInputParams: function (params = {}) {
    store.donateForm.optimizelyParams = params;
    store.donateForm.setOptimizelyAmount();
  },

  setAmountInput: function (params) {
    store.donateForm.amount = params;
  },

  setDonateFormStep: function (step) {
    store.donateForm.step = step;
  },
};

export default AmountButtonsExperiment;
